import { Button, Stack, Typography } from "@mui/material";
import { colors } from "@zfp-akademie-a-s/zfp-design";
import { AddIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { Popper } from "Components/_Shared/Popper";
import type { RiskRiskType } from "Infrastructure/ApiZfp/Schema";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { RISK_TYPE_RESOURCE_KEY } from "Infrastructure/Utils/InsuranceUtils";
import { useState } from "react";

type Props = {
  items: RiskRiskType[];
  onClick: (value: RiskRiskType) => void;
};

export const RiskInsuranceAdd = ({ items, onClick }: Props) => {
  const { t } = useResource();
  const [riskDropdownOpen, setRiskDropdownOpen] = useState(false);

  return (
    <Popper
      placement="bottom-start"
      isOpen={riskDropdownOpen}
      onOpen={() => {
        setRiskDropdownOpen(true);
      }}
      btnEl={
        <Button variant="text" sx={{ width: "fit-content", marginLeft: "-16px !important" }} startIcon={<AddIcon />}>
          {t(Resources.AnalysisDetail.AssetsAndContracts.AddAnotherRisk)}
        </Button>
      }
    >
      <Stack
        spacing={Spacing.M}
        paddingY={Spacing.S}
        display="flex"
        justifyContent="space-between"
        sx={{
          maxHeight: 200,
          overflowY: "scroll",
        }}
      >
        {items.map((value) => (
          <Stack
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              paddingX: Spacing.M,
              paddingY: Spacing.S,
              borderRadius: Radius.S,
              "&:hover": {
                cursor: "pointer",
                background: colors.backgroundSecondary,
              },
            }}
            key={value}
            onClick={() => {
              onClick(value);
              setRiskDropdownOpen(false);
            }}
          >
            <Typography variant="body2" fontWeight={600}>
              {t(Resources.AnalysisDetail.Insurance.InsuranceRiskType[RISK_TYPE_RESOURCE_KEY[value]])}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Popper>
  );
};
